import {
  IEventSender, IResponseProcessor,
} from './interfaces'
import { ResponseHandlers } from './enums'
import ActiveConfig from './activeConfig'
import { logger } from '../utils'

class PsmResponseProcessor implements IResponseProcessor {
  constructor() {
  }

  handleResponse(response: Response, eventSender: IEventSender): void {
    logger('Response Status Code: ', response.status)
    const processorConfig = ActiveConfig.responseProcessorConfig
    // TODO: add util function to be used in find() to match status codes to string globs, e.g. '50*' or '5**'
    const handler = processorConfig.find(config => config.code === response.status)
    this.callHandler(handler.handlerFunction, eventSender)
  }

  callHandler(handlerFunction: string, eventSender: IEventSender): void {
    switch (handlerFunction) {
      case ResponseHandlers.Success:
        this.handleSuccess(eventSender)
        break
      case ResponseHandlers.Failure:
        this.handleFailure(eventSender)
        break
      case ResponseHandlers.Retry:
        this.handleRetry()
        break
    }
  }

  handleSuccess(eventSender: IEventSender): void {
    logger('success')
    eventSender.clearDispatchQueue()
  }

  handleFailure(eventSender: IEventSender): void {
    logger('failure')
    eventSender.clearDispatchQueue()
  }

  handleRetry(): void {
    logger('retry')
    // do nothing, events will be re-sent on next call of sendEvents
  }
}

export default PsmResponseProcessor
